import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import styled from 'styled-components';
import DistributionLandingPageSteps from './DistributionLandingPageSteps';
import { Container } from '../../VuexyDesign/atoms/_index';

const DistributionLandingStepsContainer = () => {
  const { t } = useTranslation('organisms');
  return (
    <DistributionLandingStepsContainerWrapper>
      <Container className="gradient-text-distribution-landing-steps">
        <div className="d-flex justify-content-center align-items-center mt-2">
          <h2 className="custom-heading-font-2">
            {t('organisms:controlYourMusic')}
          </h2>
        </div>
        <DistributionLandingPageSteps
          title={t('organisms:distributeYourMusicEverywhere')}
          secondTitle={t('organisms:submitYourReleaseForDistribution')}
          desc={t('organisms:scheduleYourReleaseSelect')}
          imgUrl="/static/images/distribution-landing/submit.png"
          isSecondary
          buttonText={['Distribute your music', 'Distribute your music']}
        />

        <DistributionLandingPageSteps
          title={t('organisms:makeMoney')}
          secondTitle={t('organisms:getLiveStatistics')}
          desc={t('organisms:getDetailedInsights')}
          imgUrl="/static/images/distribution-landing/insights.webp"
          buttonText={[t('organisms:earnMoney'), t('organisms:earnMoney')]}
        />

        <DistributionLandingPageSteps
          title={t('organisms:marketingTools')}
          secondTitle={t('organisms:wellPromoteYourMusic')}
          desc={t('organisms:weWillUseOurDatabase')}
          imgUrl="/static/images/distribution-landing/promote-music.webp"
          isSecondary
          buttonText={['Distribute your music', 'Distribute your music']}
        />
      </Container>
    </DistributionLandingStepsContainerWrapper>
  );
};

export default DistributionLandingStepsContainer;
const DistributionLandingStepsContainerWrapper = styled.div`
  margin-right: 1rem;
  margin-left: 1rem;
  margin-bottom: 6rem;
  .gradient-text-distribution-landing-steps {
    border: 1px solid transparent;
    border-radius: 20px;
    background: linear-gradient(135deg, #fcf3f8 0%, #f5f8fe 100%),
      linear-gradient(to left, #743ad5, #d53a9d);
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
  }
`;
